<script lang="ts">
    import { 
        currentProductStore as product, 
        showStore as show, 
        currentVariantStore as currentVariant, 
    } from '../../../stores'
    import {ShowType} from '../../../types/Show'
    import translate from '../../../../../lib/translate'
    import label from './ProductVariants.translation'
    
    // we need a local variable for the creation dropdowns, otherwise the select does not map the empty state 
    
    let currentMaterial: string = ''
    let currentRingsize: string = ''
    
    currentVariant.subscribe((currentVariantStore) => {
        currentMaterial = currentVariantStore.material || '' 
        currentRingsize = currentVariantStore.ringsize || '' 
    })
</script>

{#if $product}
    {#if $show.meta?.type === ShowType.MultiCreation || 
         $show.meta?.type === ShowType.SingleCreation
    }
        <p>{translate(label.selectHint)}</p>
        
        {#if $product.availableVariantAspects.material && !$product.availableVariantAspects.ringsize}
            
            <div class="variants-show variants-show-buttons">
                {#each $product.availableVariantAspects.material as material}
                    <span class="btn variants-show-button {material === $currentVariant.variant?.material ? 'selected' : ''}"
                          on:click={() => currentVariant.selectMaterial(material)}>
                        {translate(label.variantMaterial(material))}
                    </span>
                {/each}
            </div>
            
        {:else}
            <div class="creation-show creation-show-selects">
                {#if $product.availableVariantAspects.material}
                    <div class="select-box-wrapper">
                        <label for="agent-show-product-variants-select-material">{translate(label.material)}</label>
                        <div class="select-box">
                            <select name="agent-show-product-variants-select-material" 
                                    id="agent-show-product-variants-select-material"
                                    on:change={(event) => { currentVariant.selectMaterial(event.target.value === '' ? null : event.target.value) }}
                                    bind:value={ currentMaterial }
                            >
                                <option value="">{translate(label.pleaseSelect)}</option>
                                {#each $product.availableVariantAspects.material as material}
                                    <option value="{material}">
                                        {translate(label.variantMaterial(material))}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    </div>
                {/if}
                {#if $product.availableVariantAspects.ringsize}
                    <div class="select-box-wrapper">
                        <label for="agent-show-product-variants-select-ringsize">{translate(label.ringsize)}</label>
                        <div class="select-box">
                            <select name="agent-show-product-variants-select-ringsize" 
                                    id="agent-show-product-variants-select-ringsize"
                                    on:change={(event) => { currentVariant.selectRingsize(event.target.value === '' ? null : event.target.value) }}
                                    bind:value={ currentRingsize }
                            >
                                <option value="">{translate(label.pleaseSelect)}</option>
                                {#each $product.availableVariantAspects.ringsize as ringsize}
                                    <option value="{ringsize}">
                                        {translate(label.ringsize)}
                                        {translate(label.variantRingsize(ringsize))}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    </div>
                {/if}
            </div>
        {/if}
        
    {:else if $product.variants.length > 1}
        
        <p class="variants-show-select-hint">{translate(label.selectHint)}</p>
        <div class="variants-show variants-show-buttons">
            {#each $product.variants as variant}
                <span class="btn variants-show-button
                             {variant.ringsize ? 'ringsize-variant' : ''}
                             {variant.available ? '' : 'deactivated'}
                             {variant.variantId === $currentVariant.variant?.variantId ? 'selected' : ''}"
                      on:click={() => { currentVariant.selectVariant(variant.variantId) }}
                >
                    {#if variant.material === 'OT' && variant.ringsize}
                        {translate(label.ringsize)}
                    {:else if variant.material}
                        {translate(label.variantMaterial(variant.material))}
                    {/if}
                    {#if variant.ringsize} 
                        <span class="ringsize-bubble">
                            {translate(label.variantRingsize(variant.ringsize))}
                        </span>
                    {/if}
                </span>
            {/each}
        </div>
        
    {/if}
{/if}